"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var styleFactory = function (_a) {
    var top = _a.top, bottom = _a.bottom, left = _a.left, right = _a.right, inline = _a.inline, inner = _a.inner;
    var style = {
        display: inline ? "inline-block" : "block"
    };
    if (inner) {
        style.paddingTop = top;
        style.paddingBottom = bottom;
        style.paddingLeft = left;
        style.paddingRight = right;
    }
    else {
        style.marginTop = top;
        style.marginBottom = bottom;
        style.marginLeft = left;
        style.marginRight = right;
    }
    return style;
};
exports.default = (function (_a) {
    var right = _a.right, left = _a.left, top = _a.top, bottom = _a.bottom, inner = _a.inner, children = _a.children, _b = _a.type, type = _b === void 0 ? "div" : _b, innerRef = _a.innerRef, _c = _a.inline, inline = _c === void 0 ? true : _c, others = tslib_1.__rest(_a, ["right", "left", "top", "bottom", "inner", "children", "type", "innerRef", "inline"]);
    return React.createElement(type, tslib_1.__assign({ style: styleFactory({ top: top, bottom: bottom, left: left, right: right, inline: inline, inner: inner }), ref: innerRef }, others), children);
});
